import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-patient-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './patient-footer.component.html',
  styleUrls: ['./patient-footer.component.scss']
})
export class PatientFooterComponent {
  footerPrefix = new Date().getFullYear();
}
